// @ts-nocheck
import Editor from './../../../../components/Editor/Editor';
import ContactInformation from '../ContactInformation/ContactInformation';
import Header from '../Header/Header';
import TripCountdown from '../TripCountdown/TripCountdown';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { hasTripStarted } from '../../helpers/dates';
import { useOnlineStatus } from '../../context/OnlineStatusContext/OnlineStatusContext';
import './TripOverview.css';

const TripOverview = ({ tripData = {} }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsShowMore, setNeedsShowMore] = useState(false);
  const { description, startdate, operatorContact } = tripData || {};
  const tripStarted = hasTripStarted(startdate);
  const contacts =
    operatorContact?.email || operatorContact?.phone
      ? [
          {
            id: 'operator-contact',
            name:
              operatorContact?.name ||
              tripData?.tenant?.tenantname ||
              operatorContact?.email ||
              operatorContact?.phone,
            phone: operatorContact?.phone || '',
            email: operatorContact?.email || '',
            type: 'primary'
          }
        ]
      : [];
  const showContactInfo = false; //contacts.length > 0; TODO: Use commented code for this line when contact info is ready, see ticket #3280 for details
  const { isOnline } = useOnlineStatus();

  // Check if description needs "Show More" functionality
  useEffect(() => {
    if (description && description.length > 200) {
      setNeedsShowMore(true);
    } else {
      setNeedsShowMore(false);
    }
  }, [description]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={`trip-overview ${!isOnline ? 'trip-overview__offline-margin' : ''}`}
    >
      <Header tripData={tripData} />
      {/* Trip Countdown */}
      {!tripStarted && (
        <section>
          <TripCountdown
            id={'pwa-trip-countdown'}
            tripStartDate={tripData?.startdate}
          />
        </section>
      )}

      {/* Mobile Description Below Image (Variant 1) */}
      {description && (
        <section className='trip-overview__section'>
          <div
            className={`trip-overview__description-container ${
              !isExpanded
                ? 'trip-overview__description-container--collapsed-mobile '
                : ''
            }`}
          >
            <Editor
              editable={false}
              isPreviewing={true}
              content={description}
              id='pwa-trip-description-editor'
              setDescription={() => {}}
              setMarkdown={() => {}}
              showActions={true}
              placeholder={``}
              generatePrompt={null}
              setIsPreviewing={() => {}}
            />

            {/* Gradient overlay when collapsed */}
            {!isExpanded && needsShowMore && (
              <div className='trip-overview__description-gradient' />
            )}
          </div>

          {/* Show More/Less Link */}
          {needsShowMore && (
            <div className='trip-overview__show-more-container'>
              <span
                className='trip-overview__show-more-link'
                onClick={toggleExpanded}
                role='button'
                tabIndex={0}
                aria-expanded={isExpanded}
                aria-controls={`pwa-trip-description-editor`}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleExpanded();
                  }
                }}
              >
                {isExpanded ? 'Show less' : 'Show more'}
              </span>
            </div>
          )}
        </section>
      )}
      {/* Contact Information */}
      {showContactInfo && (
        <section className='trip-overview__section'>
          <ContactInformation contacts={contacts} />
        </section>
      )}
    </div>
  );
};

TripOverview.propTypes = {
  id: PropTypes.string.isRequired,
  tripData: PropTypes.object.isRequired
};

export default TripOverview;
